import * as React from "react";
import { withLocalization, LocalizedComponentProps, LocalizedComponentClass, Localization } from "bernie-l10n";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";

interface ReviewAuthorAndPostedDateProps extends LocalizedComponentProps {
  authorName: string;
  authorLocation: string;
  hotelName: string;
  datePosted: Date;
  index: number;
}

const ReviewAuthorAndPostedDate = (props: ReviewAuthorAndPostedDateProps) => (
  <Viewport>
    <ViewSmall>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-bold">
          {getAuthorFromCityStayedAtHotelText(props.authorName, props.authorLocation, props.hotelName, props.l10n)}
        </div>
        <div id={`postedText-${props.index}`}>{getPostedAgoText(props.datePosted, props.l10n)}</div>
      </div>
    </ViewSmall>
    <ViewMedium>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-200">
          {getAuthorFromCityStayedAtHotelText(props.authorName, props.authorLocation, props.hotelName, props.l10n)}
        </div>
        <div className="uitk-type-200" id={`postedText-${props.index}`}>
          {getPostedAgoText(props.datePosted, props.l10n)}
        </div>
      </div>
    </ViewMedium>
  </Viewport>
);

const getAuthorFromCityStayedAtHotelText = (
  authorName: string,
  authorLocation: string,
  hotelName: string,
  l10n: Localization
) => {
  if (authorName) {
    return authorLocation
      ? l10n.formatText("hotelRecentReviews.authorText", authorName, authorLocation, hotelName)
      : l10n.formatText("hotelRecentReviews.authorTextWithoutCity", authorName, hotelName);
  }

  return authorLocation
    ? l10n.formatText("hotelRecentReviews.noNameAuthorText", authorLocation, hotelName)
    : l10n.formatText("hotelRecentReviews.noNameAuthorTextWithoutCity", hotelName);
};

const getPostedAgoText = (datePosted: Date, l10n: Localization) => {
  // Handle by hours
  const hoursAgo = convertToHoursAgo(datePosted);
  const daysAgo = Math.round(hoursAgo / 24);
  const weeksAgo = Math.round(daysAgo / 7);
  const monthsAgo = Math.round(weeksAgo / 4);
  const yearsAgo = Math.round(monthsAgo / 12);

  switch (true) {
    case hoursAgo === 0:
      return l10n.formatText("hotelRecentReviews.postedLessThanAnHourAgo");
    case hoursAgo === 1:
      return l10n.formatText("hotelRecentReviews.postedOneHourAgo");
    case hoursAgo < 24:
      return l10n.formatText("hotelRecentReviews.postedHoursAgo", hoursAgo);
    case daysAgo === 1:
      return l10n.formatText("hotelRecentReviews.postedOneDayAgo");
    case daysAgo < 14:
      return l10n.formatText("hotelRecentReviews.postedDaysAgo", daysAgo);
    case weeksAgo === 2 || weeksAgo === 3:
      return l10n.formatText("hotelRecentReviews.postedWeeksAgo", weeksAgo);
    case monthsAgo === 1:
      return l10n.formatText("hotelRecentReviews.postedOneMonthAgo");
    case monthsAgo < 12:
      return l10n.formatText("hotelRecentReviews.postedMonthsAgo", monthsAgo);
    case yearsAgo === 1:
      return l10n.formatText("hotelRecentReviews.postedOneYearAgo");
    default:
      return l10n.formatText("hotelRecentReviews.postedOverYearAgo");
  }
};

const convertToHoursAgo = (date: Date) => {
  const today = new Date();
  const datePosted = new Date(date);

  return Math.abs(Math.floor((today.getTime() - datePosted.getTime()) / 1000 / (60 * 60)));
};

export const LocalizedReviewAuthorAndPostedDate: LocalizedComponentClass<ReviewAuthorAndPostedDateProps> = withLocalization(
  ReviewAuthorAndPostedDate
);
